import { createContext } from 'react';

import { WorkbenchLocaleContextType } from './types';

const WorkbenchLocaleContext = createContext<WorkbenchLocaleContextType>({
  workbenchLocale: undefined,
});

export default WorkbenchLocaleContext;
